import React from 'react';
import axios from 'axios';

import Loading from '../Loading'

import styles from '../../styles/DynamicModal.module.css';

import IconContainer from '../IconContainer';
import { ReactComponent as XIcon } from '../../icons/x-close.svg';

export default function EditRegion({ closeModal, id, action, onReloadTable }) {
    const [formInfo, setFormInfo] = React.useState({
        name: '',
    });
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }
    React.useEffect(() => {
        if (action=='change') {
            const token = localStorage.getItem('token');
            if (!token) handleLogout();
            setStatus(<a><Loading type='inline' /></a>);

            axios.get(`/api/get-region?id=${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then(response => {
                setFormInfo(response.data);
                setStatus(null);
            }).catch((error) => {
                console.error(error);
                setStatus(<a className='mainLabelError'>Не удалось загрузить данные региона. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        } else {
            setLoading(false);
        }
    }, []);

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        setFormInfo((prev) => ({ ...prev, [field]: value }));

        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };

    const [errorsForm, setErrorsForm] = React.useState({});
        const validateForm = () => {
        const newErrors = {};
    
        if (!formInfo.name) {
            newErrors.name = 'Обязательное поле';
        }
        if (formInfo.name && (formInfo.name.length < 2 || formInfo.name.length > 50)) {
            newErrors.name = 'Значение не может быть меньше 2 и более 50 символов';
        }
    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const addData = () => {
        axios.post('/api/add-new-region', {
            name: formInfo.name,
        })
        .then(() => {
            setStatus('Новый регион добавлен');
            onReloadTable();
        })
        .catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    };

    const changeData = () => {
        axios.put(`/api/change-region`, {
            id: formInfo.id,
            name: formInfo.name,
        }).then(() => {
            setStatus('Данные региона изменены');
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    };

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            if (action=='add') addData();
            if (action=='change') changeData();
        }
        setLoading(false);
    };


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>{action=='add' && 'Добавление'} 
                        {action=='change' && 'Редактирование'}
                        &nbsp;региона
                    </h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <div className='labelInputWrapper'>
                        <a className='label'>Название региона</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.name} 
                                onChange={handleChange('name')} 
                                className={errorsForm.name ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='50' 
                                disabled={loading}
                                required />
                                {errorsForm.name && <div className='errorUnderInput'>{errorsForm.name}</div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <button 
                        type='button' 
                        className='button' 
                        onClick={handleSave}
                        disabled={loading}
                    >
                        {action=='add' && 'Добавить'} 
                        {action=='change' && 'Изменить'} 
                    </button>
                </div>
            </div>
        </div>
    )
}
